import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import styled from 'styled-components';
import { Row, Button, Separator } from '@cuemath/comps';

import { get as getListCount } from 'actions/list-count';
import { getAll as getStudentList } from 'actions/student-list';
import { openModal, closeModal } from 'actions/modal';
import { patch as editStudent } from 'actions/students';

import StudentSlotList from './list';
import { FORM_ACTIONS, MODAL_FORM } from 'constants/form';
import MODAL from 'constants/modal';

const Head = styled(Row)`
  width: 100%;
  padding-left: 15px;
  padding-right: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const ButtonWrapper = styled(Button)`
  margin: 0 5px;
`;

class StudentSlots extends PureComponent {
  onCreateDemo = () => {
    const { actions, studentProfileInfo: student } = this.props;
    actions.openModal(
      MODAL_FORM.CREATE_DEMO_SLOT,
      {
        size: 'custom',
        width: `${Math.ceil((window.innerWidth * 60) / 100)}px`,
        height: MODAL.HEIGHT,
      },
      { formType: FORM_ACTIONS.CREATE, studentId: student.id },
    );
  };

  openEditStudentSlotForm = ({ formType, data, courses }) => {
    const { actions } = this.props;

    if (FORM_ACTIONS.hasOwnProperty(formType)) {
      actions.openModal(
        MODAL_FORM.EDIT_STUDENT_SLOT,
        {
          size: 'custom',
          width: `400px`,
          height: '350px',
        },
        { formType, data, courses },
      );
    }
  };

  render() {
    const {
      addSlotButtons,
      studentProfileInfo: { slots, courses = [] },
    } = this.props;

    return (
      <React.Fragment>
        <Separator transparent height="10" />
        <Head>
          {addSlotButtons && (
            <ButtonWrapper label="Create Test Slot" onClick={this.onCreateDemo} />
          )}
        </Head>
        <Separator transparent height="10" />
        <StudentSlotList
          students={!!slots ? [...slots.active_slots, ...slots.expired_slots] : []}
          courses={courses}
          openEditStudentSlotForm={this.openEditStudentSlotForm}
        />
      </React.Fragment>
    );
  }
}

export default withRouter(
  connect(
    ({ studentList, listCount, students, studentSlots }) => ({
      studentList,
      listCount,
      students,
      studentSlots,
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getListCount,
          getStudentList,
          openModal,
          editStudent,
          closeModal,
        },
        dispatch,
      ),
    }),
  )(StudentSlots),
);
